import styled from 'styled-components';
import colors from '../../../../helpers/colors';
import fonts from '../../../../helpers/fonts';
import mediaQuery from '../../../../helpers/mediaQuery';
import Link from '../../../Link';
import { centredIconAndTextStyles } from '../../commonStyles/secondaryNavStyles';

export const NavItemLink = styled(Link)`
  width: 100%;
  margin: auto;
  &:focus-visible:after {
    position: absolute;
    content: '';
    top: 5px;
    bottom: 0px;
    left: 5px;
    right: 5px;
    border-radius: 8px;
  }
`;

export const SecondaryNavItemText = styled.span`
  ${fonts.paragraph}
  & {
    color: ${colors.neutral08};
    font-weight: lighter;
    font-weight: 400;
    line-height: 1.5rem; /* 24px */
    font-size: 0.875rem;
  }
  padding: 0;
  margin: 12px 0;

  justify-content: space-around;
  ${centredIconAndTextStyles}
`;

export const InlineSecondaryNav = styled.div`
  display: flex;
  ${mediaQuery.tabletLandscape`
     display: none;
  `}
`;
export const SecondaryNavItemWrapper = styled.div`
  display: flex;
  flex: auto;
  &:not(:last-child):after {
    content: '';
    width: 1px;
    height: 16px;
    background: ${colors.neutral08};
    margin: auto;
  }
`;
